const translations = {
  fr: {
    salesInventory: {
      spotsPerWeek: 'Horaire des spots',
      from: 'de',
      to: 'à',
      errorLoadingSpotSchedule: 'Une erreur est survenue lors du chargement de l\'horaire des spots',
      saveSpotSchedule: 'Enregistrer cet horaire',
      addSpotScheduleTimeSlot: 'Ajouter une nouvelle plage de spots',
      editSpotScheduleTimeSlot: 'Modifier une plage de spots',
      save: 'Enregistrer',
      create: 'Créer',
      numberOfSpots: 'Nombre de spots',
      timeSlot: 'Plage d\'heures',
      invalidNumberOfSpots: 'Le nombre de spots entré doit être supérieur à zéro',
      updateError: 'Une erreur est survenue lors de la sauvegarde de l\'horaire des spots',
      spotScheduleUpdated: 'L\'horaire a été mis à jour',
      spotScheduleTimeSlotIsConflicting: 'Cette plage de spots entre en conflit avec d\'autres plages de spots',
      spotScheduleTimeSlotIsConflicting_plural: 'Certaines plages de spots entre en conflit avec d\'autres plages de spots',
      deleteSpotScheduleTimeSlot: 'Supprimer cette plage',
      confirmDeleteSpotScheduleTimeSlot: 'Voulez-vous vraiment supprimer cette plage?',
      yesDelete: 'Oui, supprimer',
      noDelete: 'Annuler',
      addTimeSlot: 'Ajouter une plage',
      day: 'Jour',
      back: 'Retour',
    },
  },
  en: {
    salesInventory: {
      spotsPerWeek: 'Spot schedule',
      from: 'from',
      to: 'to',
      errorLoadingSpotSchedule: 'An error occured when loading the spot schedule',
      saveSpotSchedule: 'Save this schedule',
      addSpotScheduleTimeSlot: 'Add a new spot schedule time slot',
      editSpotScheduleTimeSlot: 'Edit a spot schedule time slot',
      save: 'Save',
      create: 'Create',
      numberOfSpots: 'Number of spots',
      timeSlot: 'Time slot',
      invalidNumberOfSpots: 'The number of spots must be superior to zero',
      updateError: 'An error occured when saving the spot schedule',
      spotScheduleUpdated: 'The schedule has been saved',
      spotScheduleTimeSlotIsConflicting: 'This spot time slot is in conflict with an existing one',
      spotScheduleTimeSlotIsConflicting_plural: 'Some spot time slots are in conflict with an existing one',
      deleteSpotScheduleTimeSlot: 'Delete this time slot',
      confirmDeleteSpotScheduleTimeSlot: 'Do you really want to delete this time slot?',
      yesDelete: 'Yes, delete',
      noDelete: 'Cancel',
      addTimeSlot: 'Add a new time slot',
      day: 'Day',
      back: 'Back',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesInventory/i18n/salesInventory.js